/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Direction_Undetermined12Inputs */



/**

* @param {_Field__Enum_Direction_Undetermined12Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_direction_undetermined12 = /** @type {((inputs?: _Field__Enum_Direction_Undetermined12Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Direction_Undetermined12Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Unbestimmt")
});
export { _field__enum_direction_undetermined12 as "_field__enum_direction_UNDETERMINED" }